module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ignite-session-21-feb-2026.json
// module id = 1357
// module chunks = 193786031782092